import { Burger } from '@octopus-do/octopus-storybook/icons'
import type { Workspace } from '@store/reducers/dashboard/types'
import type React from 'react'

import { UserMenu } from '@/components/UserMenu'
import css from './styles.module.css'

interface Props {
  onOpenSidebar: () => void
  workspace: Workspace
}

export const DashboardHeader: React.FC<Props> = ({
  onOpenSidebar,
  workspace,
}) => {
  return (
    <div className={css.header}>
      <button className={css.header_burger_btn} onClick={onOpenSidebar}>
        <div className={css.header_burger_icon}>
          <Burger />
        </div>
        <div className={css.header_burger_title}>{workspace.title}</div>
      </button>

      <div className={css.header_left_col}>
        <UserMenu />
      </div>
    </div>
  )
}
